export const CustomEditIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3790_3398)">
        <path
          d="M7.33325 2.66663H2.66659C2.31296 2.66663 1.97382 2.8071 1.72378 3.05715C1.47373 3.3072 1.33325 3.64634 1.33325 3.99996V13.3333C1.33325 13.6869 1.47373 14.0261 1.72378 14.2761C1.97382 14.5262 2.31296 14.6666 2.66659 14.6666H11.9999C12.3535 14.6666 12.6927 14.5262 12.9427 14.2761C13.1928 14.0261 13.3333 13.6869 13.3333 13.3333V8.66663"
          stroke="#676267"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3333 1.66665C12.5985 1.40144 12.9582 1.25244 13.3333 1.25244C13.7083 1.25244 14.068 1.40144 14.3333 1.66665C14.5985 1.93187 14.7475 2.29158 14.7475 2.66665C14.7475 3.04173 14.5985 3.40144 14.3333 3.66665L7.99992 9.99999L5.33325 10.6667L5.99992 7.99999L12.3333 1.66665Z"
          stroke="#676267"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3790_3398">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
